{
  "search_count": "Caută {count} {noun}",
  "nouns": { "used": "mașini", "truck": "autoutilitare", "motorcycle": "motociclete" },
  "tabs": { "truck": "Autoutilitare" },
  "search_reassurance": "Fără comision. Suni direct vânzătorul.",
  "call": "Sună",
  "whatsapp": "WhatsApp",
  "message": "Trimite mesaj",
  "unspecified": "Nespecificat de vânzător",
  "passenger_total": "autoturisme și SUV-uri",
  "hero_active": "{count} anunțuri active.",
  "hero_direct": "Suni direct vânzătorul.",
  "trust_active": "{count} anunțuri active",
  "trust_dealers": "{count} dealeri verificați",
  "trust_commission": "0% comision pentru cumpărători",
  "sort_label": "Sortează",
  "sort_options": { "newest": "Cele mai recent adăugate", "price_asc": "Preț crescător", "price_desc": "Preț descrescător", "year_desc": "An: cele mai noi", "mileage_asc": "Kilometraj crescător" }
}